<div class="search-container">
    <ap-search-input
        [class]="searchVariant === 'modal' ? 'template-search' : ''"
        [label]="'mijn.zoeken.search.title' | apContent"
        [formControl]="searchControl"
        (search)="doSearch($event)"
    >
    </ap-search-input>
    @if (searchVariant === 'modal' && !searchTerm) {
        <div class="search-results">
            <h3>
                {{ 'mijn.zoeken.search.recent' | apContent }}
            </h3>
            <hr />
            @for (item of recentResults; track item) {
                @if (item.title) {
                    <ul class="ap-item-list">
                        <li
                            ap-list-item
                            [isTitleBold]="true"
                            [actionType]="item.actionType"
                            [title]="item.title"
                            [showTopBorder]="false"
                            [showBottomBorder]="true"
                            [subTitle]="item.subTitle"
                            (itemClicked)="openLink(item)"
                        >
                            >
                        </li>
                    </ul>
                }
            }
        </div>
    }
    @if (searchTerm) {
        <div class="search-results">
            @if (!searchResults || searchResults.length === 0) {
                <h3>
                    {{ 'mijn.zoeken.search.noResults' | apContent }}
                </h3>
            }
            @if (!searchResults || searchResults.length === 0) {
                <hr />
            }
            @for (item of searchResults; track item) {
                <ul class="ap-item-list">
                    <li
                        ap-list-item
                        [isTitleBold]="true"
                        [actionType]="item.actionType"
                        [title]="item.title"
                        [showTopBorder]="false"
                        [showBottomBorder]="true"
                        [subTitle]="item.subTitle"
                        (itemClicked)="openLink(item)"
                    >
                        >
                    </li>
                </ul>
            }
            @if (searchResultsSug && searchResultsSug.length > 0) {
                <h3 class="search-suggestions-header">
                    {{ 'mijn.zoeken.search.suggestions' | apContent }}
                </h3>
            }
            @for (item of searchResultsSug; track item) {
                <ul class="ap-item-list">
                    <li
                        ap-list-item
                        [isTitleBold]="true"
                        [actionType]="item.actionType"
                        [title]="item.title"
                        [showTopBorder]="false"
                        [showBottomBorder]="true"
                        [subTitle]="item.subTitle"
                        (itemClicked)="openLink(item)"
                    >
                        >
                    </li>
                </ul>
            }
        </div>
    }
</div>
